import axios from 'axios';

export default axios.create({
  baseURL: 'https://berates.v3.voice.weepee.io/publicapi/5d7ac05e87f341a8a60ed4117ea7b7c4'
});

